import { Divider, TabButtonGroup } from '@epilot/concorde-elements'
import { clsx } from '@epilot/journey-logic-commons'
import type { ComponentProps } from 'react'

import { useAppStoreSelector } from '../../hooks/useAppStoreSelector'
import { journeySelect } from '../../store/actions/journeySelect'
import {
  selectLauncherJourneyOrThrow,
  selectSelectedJourneyId
} from '../../store/selectors/config'
import { useWrapperStyles } from '../JourneyPage/styles'

import { EmptyJourneyLauncher } from './EmptyJourneyLauncher'
import controlClasses from './JourneyLauncherControl.module.scss'
import tabsClasses from './JourneyLauncherTabs.module.scss'
import { getLauncherTabs } from './utils'

export type BaseJourneyLauncherTabsProps = ComponentProps<'div'> & {
  isFocusedOnJourney: boolean
  showPaper: boolean
}

export const JourneyLauncherTabs = ({
  children,
  isFocusedOnJourney,
  showPaper
}: BaseJourneyLauncherTabsProps) => {
  const launcher = useAppStoreSelector(selectLauncherJourneyOrThrow)
  const selectedJourneyId = useAppStoreSelector(selectSelectedJourneyId)

  /* Should move theme computation up to the parent component */
  const styles = useWrapperStyles({ maxWidth: 1256 })

  if (!selectedJourneyId) {
    return <EmptyJourneyLauncher />
  }

  return (
    <div
      className={clsx(
        tabsClasses.outerWrapper,
        !isFocusedOnJourney && tabsClasses.outerWrapperFocused
      )}
    >
      <div
        className={
          !isFocusedOnJourney
            ? clsx(
                controlClasses.container,
                showPaper && controlClasses.containerPaper,
                styles.wrapperStyles,
                tabsClasses.wrapperOverride
              )
            : undefined
        }
      >
        <TabButtonGroup
          activeTabId={selectedJourneyId}
          onTabChange={(id) => void journeySelect({ id })}
          style={isFocusedOnJourney ? { display: 'none' } : undefined}
          tabs={getLauncherTabs(launcher)}
        />

        <Divider
          className={controlClasses.divider}
          style={isFocusedOnJourney ? { display: 'none' } : undefined}
        />
        {children}
      </div>
    </div>
  )
}
